import gql from "graphql-tag";
export const geolocatedCurrencyQuery = gql`
  query geolocatedCurrencyQuery($countryCode: String) {
    geolocatedCurrency(countryCode: $countryCode) {
      currency {
        id
        icon
        multiplier
        name
        symbol
        zeroDecimal
      }
      countryCode
    }
  }
`;
export function useGeolocationCurrency(props) {
  var _queryResults$data, _queryResults$data2, _queryResults$error;

  const useQuery = props.useQuery;
  const queryResults = useQuery(geolocatedCurrencyQuery, {
    fetchPolicy: "no-cache",
    skip: !!props.accountCurrency
  });
  return {
    countryCode: queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$data = queryResults.data) === null || _queryResults$data === void 0 ? void 0 : _queryResults$data.geolocatedCurrency.countryCode,
    currency: queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$data2 = queryResults.data) === null || _queryResults$data2 === void 0 ? void 0 : _queryResults$data2.geolocatedCurrency.currency,
    error: (_queryResults$error = queryResults === null || queryResults === void 0 ? void 0 : queryResults.error) !== null && _queryResults$error !== void 0 ? _queryResults$error : null,
    isLoading: queryResults === null || queryResults === void 0 ? void 0 : queryResults.loading
  };
}
//# sourceMappingURL=useGeolocationCurrency.js.map
